/* unplugin-vue-components disabled */import { render } from "./MyMessage.vue?vue&type=template&id=6087ca1c&scoped=true"
import script from "./MyMessage.vue?vue&type=script&lang=js"
export * from "./MyMessage.vue?vue&type=script&lang=js"

import "./MyMessage.vue?vue&type=style&index=0&id=6087ca1c&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\Public\\object\\xvideos-frontend\\mysex\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6087ca1c"]])

export default __exports__